/* eslint-disable react/display-name */
import styles from './PrinceInfo.module.css';
import { BundleUpchargeStore, BundleUpchargeStoreGroup, Patches } from '@/types/bundles.types';
import { CellContext } from '@tanstack/react-table';
import _ from 'lodash';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import { formatDisplayUpchargePrice } from '@/services/bundles/bundles.service.helper';

export const PriceInfo =
  (header: string, onInfoClick: (product: any, groupId: any) => void) =>
  ({ row }: CellContext<BundleUpchargeStoreGroup, unknown>) => {
    const product = row.original.patches?.find((item: Patches) => item?.description === header);
    const storeGroup = row.original;
    const noStores = formatDisplayUpchargePrice(product);
    return product?.price.includes('-') ? (
      <div className={styles.rangePriceCell}>
        <div>{`$${product?.price}`}</div>
        <InfoOutlined
          className={styles.priceRangeInfo}
          sx={{
            width: '22px',
            height: '22px',
            color: '#266DCC',
          }}
          onClick={() => onInfoClick(product, storeGroup.storeGroupId)}
        />
      </div>
    ) : (
      noStores
    );
  };

export const PriceInfoGroupStore =
  (header: string, onInfoClick: (product: any, groupId: any) => void) =>
  ({ row }: CellContext<BundleUpchargeStoreGroup, unknown>) => {
    const product = row.original.patches?.find((item: Patches) => item?.description === header);
    const noStores = product?.price ? `$${product?.price}` : 'None';
    const { storeGroupId } = row.original;
    return product?.price.includes('-') ? (
      <div className={styles.rangePriceCell}>
        <div>{`$${product?.price}`}</div>
        <InfoOutlined
          className={styles.priceRangeInfo}
          sx={{
            width: '22px',
            height: '22px',
            color: '#266DCC',
          }}
          onClick={() => onInfoClick(product?.type, storeGroupId)}
        />
      </div>
    ) : (
      noStores
    );
  };

export const PriceInfoStores =
  (header: string, onInfoClick: (product: any, groupId: any) => void) =>
  ({ row }: CellContext<BundleUpchargeStore, unknown>) => {
    const products = row.original.patches?.filter((item: any) => item?.description === header);
    let noStores = 'None';
    let price = '';
    const storeGroup = row.original;

    if (products && products.length > 1) {
      const prices = products.map((product: any) => product.price);
      const minPrice = Math.min(...prices).toFixed(2);
      const maxPrice = Math.max(...prices).toFixed(2);
      price = minPrice === maxPrice ? `$${minPrice}` : `$${minPrice} - ${maxPrice}`;
    } else if (products && products.length === 1) {
      noStores = products[0]?.price ? `$${Number(products[0]?.price).toFixed(2)}` : 'None';
      price = products[0]?.price ? products[0]?.price?.toString() || '' : '';
    }

    return price.includes('-') ? (
      <div className={styles.rangePriceCell}>
        <div>{`${price}`}</div>
        <InfoOutlined
          className={styles.priceRangeInfo}
          sx={{
            width: '22px',
            height: '22px',
            color: '#266DCC',
          }}
          onClick={() => onInfoClick(header, storeGroup)}
        />
      </div>
    ) : (
      noStores
    );
  };
